import type React from 'react';
import type { ArticleCarouselComponent } from 'api/types';
import BaseArticleStep from '../BaseArticleStep/BaseArticleStep';

interface ArticleStepProps {
  isLastStep: boolean;
  stepIndex: number;
  /**  Component's data */
  widgetComponent: ArticleCarouselComponent;
}

const ArticleStep: React.FC<
  React.PropsWithChildren<ArticleStepProps>
> = props => {
  return <BaseArticleStep {...props} isAgathaMessageVisible={false} />;
};

export default ArticleStep;
